var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-text-field',_vm._b({attrs:{"value":_vm.modelValue},on:{"input":(newValue) => (_vm.modelValue = newValue),"keypress":_vm.keyPress}},'v-text-field',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }